export enum MembershipOnboardingStepsEnum {
    PersonalDetails = 'Personal details',
    PostalAddress = 'Postal address',
    Location = 'Location',
    OnboardingInformation = 'Onboarding information',
    DeclarationAndPetition = 'Declaration and petition'
}